<template>
  <div ref="selectRef">
    <!-- 选择 -->
    <div :class="$style.searchWrapper" @click="togglePane" ref="coinRightSelectBtnRef">
      <div v-if="isFait" :class="$style.fiatIcon">
        {{ fiatJSON[currentValue || 'USD'] || '$' }}
      </div>
      <img v-if="currentIcon" :src="currentIcon" alt="logo" :class="$style.fiatIcon" />

      <span :class="$style.searchLineValue">{{ currentValue }}</span>
      <r-icon
        name="icon-actions_select_down"
        :class="isOpen ? 'dealForm__icon--arrow-up' : 'dealForm__icon--arrow-down'"
      />
    </div>
    <!-- 弹框 -->
    <Teleport to="body">
      <transition name="el-zoom-in-top">
        <div :class="$style.searchPane" v-show="isOpen" :style="paneStyle" @click.stop>
          <div class="coinSelect__titBox" v-if="enableSearch">
            <div class="search__box">
              <i class="el-icon-search search__icon"></i>
              <input
                type="text"
                class="search__input ibm-font"
                :placeholder="placeholderText"
                ref="searchInput"
                v-model="searchTerm"
              />
            </div>
          </div>
          <client-only>
          <r-virtual-list
            :data="filteredOptions"
            :item-height="40"
            wrapper-class="list__coin"
            wrapper-height="344"
            key-str="id"
          >
            <template #option="{ optionData }">
              <div
                @click="onSelect(optionData)"
                :class="[$style.item, currentValue === optionData?.value ? $style.selected : '']"
              >
                <div v-if="isFait" :class="$style.fiatIcon">
                  {{ fiatJSON[optionData?.value || 'USD'] || '$' }}
                </div>
                <img
                  v-if="!isFait && optionData.iconUrl"
                  :class="$style.fiatIcon"
                  :src="optionData ? optionData.iconUrl : ''"
                  alt="logo"
                />
                <!-- <slot :data="optionData" :search-key="searchTerm"> -->
                <r-highlight-text
                  :configs="[
                    {
                      key: searchTerm,
                      color: BRAND_COLOR_CONFIG.light,
                    },
                  ]"
                  :open-case-mode="false"
                >
                  {{ optionData?.label }}
                </r-highlight-text>
                <r-icon name="icon-checkmark" v-if="currentValue === optionData?.value" style="margin-left: auto" />
                <!-- <span class="label__simpleCoin">{{ optionData ? optionData.label : '' }}</span> -->
                <!-- </slot> -->
              </div>
            </template>
          </r-virtual-list>
          </client-only>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script lang="ts">
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { fiatJSON, BRAND_COLOR_CONFIG } from '@/common/js/const';

interface OptionI {
  label?: string;
  value?: string | number;
  extraData?: string;
  key?: string | number;
  iconUrl?: string;
  disabled?: boolean;
  [key: string]: any;
}

export default {
  name: 'SearchSelect',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    isFait: { type: Boolean },
    options: {
      // Array<OptionI>
      // @ts-ignore
      type: Array,
      default: () => [],
    },

    search: {
      type: Boolean,
      default: true,
    },
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },

    searchKeyName: {
      type: String,
      default: 'label',
    },
  },
  emits: ['on-change', 'update:modelValue'],

  setup(props, { emit }) {
    const selectRef = ref(null); // 使用 ref 引用组件 DOM
    // Define reactive variables
    const isOpen = ref(false); // 搜索pane是否打开

    const currentValue = ref<string | null>(props.modelValue);

    const searchTerm = ref(''); // 用于保存搜索关键字
    const placeholderText = ref(props.searchPlaceholder); // 搜索框占位符
    const searchInput = ref(null); // 访问搜索输入框 DOM 元素

    const enableSearch = computed(()=> props.search && props.options.length > 10); // 控制搜索框是否可见

    const currentIcon = computed(() => {
      if (props.isFait || !currentValue.value) {
        return null;
      }
      const current = props.options?.find((i: any) => i?.value === currentValue.value);
      // @ts-ignore
      return current?.iconUrl;
    });

    // 计算属性：根据搜索关键字过滤币种
    const filteredOptions = computed(() => {
      const lowerSearchTerm = searchTerm.value.toLowerCase();
      const options = props.options as Array<OptionI>;
      const filteredList = options?.filter(
        (item) =>
          item.label?.toLowerCase().includes(lowerSearchTerm) || item.extraData?.toLowerCase().includes(lowerSearchTerm)
      );

      if (searchTerm.value) {
        return filteredList.sort((a, b) => {
          const lowerA = a[props.searchKeyName].toLowerCase();
          const lowerB = b[props.searchKeyName].toLowerCase();
          const matchA = lowerA === lowerSearchTerm || (a.extraData || '').toLowerCase() === lowerSearchTerm;
          const matchB = lowerB === lowerSearchTerm || (b.extraData || '').toLowerCase() === lowerSearchTerm;
          if (matchA && !matchB) return -1;
          if (!matchA && matchB) return 1;
          return 0;
        });
      }
      // console.log("数据：", filteredList);
      return filteredList;
    });

    const togglePane = () => {
      isOpen.value = !isOpen.value;

      if (isOpen.value) {
        adjustPanePosition();
      }
    };

    const paneStyle = ref({});
    const adjustPanePosition = () => {
      // @ts-ignore
      const buttonRect = selectRef.value?.getBoundingClientRect();
      // @ts-ignore
      const parentWidth = selectRef.value?.parentElement?.getBoundingClientRect().width;

      console.log(buttonRect, buttonRect.width, parentWidth);
      // console.log(buttonRect, window.scrollX);
      const paneWidth = parentWidth; //定值
      paneStyle.value = {
        position: 'absolute',
        width: `${parentWidth || 356}px !important`,
        top: `${buttonRect.bottom + 20 + window.scrollY}px`,
        left: `${buttonRect.right - paneWidth + 20 + window.scrollX}px`,
        // top: `${buttonRect.bottom + 20 + window.scrollY}px`,
        // left: `${buttonRect.left + 20 + window.scrollX}px`,
        zIndex: 1000,
      };
    };

    // 处理币种选择的函数
    const onSelect = (item: any) => {
      console.log('onSelect: ', item);
      currentValue.value = item.value;
      emit('update:modelValue', item.value);
      emit('on-change', item.value, item);
      togglePane();
    };

    watch(
      () => props.modelValue,
      (newValue) => {
        currentValue.value = newValue;
      }
    );

    // 关闭/打开时，重置搜索
    watch(isOpen, () => {
      searchTerm.value = '';
    });

    const handleClickOutside = (event: any) => {
      //
      // @ts-ignore
      if (selectRef.value && !selectRef.value?.contains(event.target)) {
        if (isOpen.value) {
          isOpen.value = false;
          console.log('==== close select cryto ==');
        }
      }
    };

    onMounted(() => {

      document?.addEventListener('click', handleClickOutside);
    });

    onBeforeUnmount(() => {
      document?.removeEventListener('click', handleClickOutside);
      // 页面卸载前恢复页面滚动
      if(window && document){
        document.documentElement.style.height = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.overflow = 'visible';
        document.body.style.overflow = 'visible';
      }
      
    });

    // 返回模板中使用的变量和方法
    return {
      BRAND_COLOR_CONFIG,
      selectRef,
      isOpen,
      currentValue,
      paneStyle,
      togglePane,
      searchTerm,
      filteredOptions,
      enableSearch,
      placeholderText,
      searchInput,
      onSelect,
      currentIcon,
      fiatJSON,
    };
  },
};
</script>

<style lang="less" module>
.searchWrapper {
  cursor: pointer;
  display: flex;
  padding: 4px;
  align-items: center;
}
.searchPane {
  position: absolute;
  max-height: 50vh;
  width: 356px;
  background-color: #ffffff;
  filter: drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.1));
  z-index: 99;
}
.searchLineValue {
  font-size: 16px;
  color: var(--color-p2p-text-primary);
  margin: 0 2px 0 4px;
}
.fiatIcon {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: var(--color-p2p-text-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}
.item {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;

  transition: all 0.3s ease;

  font-size: 14px;

  &:hover {
    background: #eef3f5;
  }

  .fiatIcon {
    margin-right: 8px;
  }
}
.item.selected {
  background: #eef3f5;
}
.itemIcon {
  width: 24px;
  height: 24px;
  border-radius: 10px;
  background-color: var(--color-p2p-text-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
</style>

<style scoped lang="less">
/* 样式内容保持不变 */
.scroll() {
  &::-webkit-scrollbar {
    height: 4px !important;
    background-color: #fafafa !important;
  }
  &::-webkit-scrollbar-thumb {
    height: 4px !important;
    background-color: #e6e8ec !important;
    border-radius: 10px !important;
  }
  &::-webkit-scrollbar-track {
    background-color: #fafafa !important;
  }
}

.coinSelect__titBox {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 36px;
  grid-auto-rows: 36px;
  box-sizing: border-box;
  padding: 10px 16px;
}

.coinSelect__tit {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.search__box {
  grid-column-start: span 2;
  background: #f2f2f2;
  display: flex;
  border-radius: 50px;
  overflow: hidden;
}

.search__icon {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef3f5;
  color: #9cb3ba;
}

.search__input {
  display: flex;
  background: #eef3f5;
  align-items: center;
  border: none;
  outline: none;
  flex-grow: 1;
  padding-right: 1em;
  font-size: 14px;
  &::-webkit-input-placeholder {
    color: #a0a4b0;
  }
}

:deep(.list__coin) {
  .scroll();
  max-height: 344px;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  overflow: auto;
}

.item__coin {
  padding: 13px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background: #f5f9fb;
  }
}

.logo__coin {
  width: 24px;
  height: 24px;
}

.label__simpleCoin {
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #2b2e36;
}

.r-search-select {
  background: #fff;
}
</style>
